export class AppAnalyticsConstants {

  // ===========Module Names ===============================

  static MODULE_NAME_BILL = 'Bill';
  static MODULE_NAME_BILL_TEMPLATES = 'Bill Templates';
  static MODULE_NAME_RECURRING_BILLS = 'Recurring Bills';
  static MODULE_NAME_EXPENSES = 'Expenses';
  static MODULE_NAME_AUTOMATION = 'Automation';
  static MODULE_NAME_PROJECT_CODE = 'Project Code';
  static MODULE_NAME_TRANSACTIONS = 'Transactions';
  static MODULE_NAME_PROCESS_TRANSACTIONS = 'Process Transactions';
  static MODULE_NAME_SUBMITTED_TRANSACTIONS = 'Submitted Transactions';
  static MODULE_NAME_ITEM = 'Items';
  static MODULE_NAME_ACCOUNT = 'Account';
  static MODULE_SUPPORT_SETTINGS = 'Support Settings';
  static MODULE_NAME_VENDOR = 'Vendor';
  static MODULE_NAME_VENDOR_GROUP = 'Vendor Group';
  static MODULE_NAME_COMMUNITY_VENDOR = 'Community Vendor';
  static MODULE_NAME_VENDOR_REQUEST = 'Vendor Requset';
  static MODULE_NAME_VIRTUAL_DIGITAL_CARD = ' Virtual/Digital Cards';
  static MODULE_NAME_INVOICE = 'Invoice';
  static MODULE_NAME_RECEIPTS = 'Receipts';
  static MODULE_NAME_APPROVED_TRANSACTIONS = 'Approved Transactions';
  static MODULE_NAME_CREDIT_CARD = 'Credit Card';
  static MODULE_NAME_PAYMENT = 'Payment';
  static MODULE_NAME_CREDIT_NOTE = 'Credit Note';
  static MODULE_NAME_PO_RECEIPT = 'Po Receipt';
  static MODULE_NAME_SUPPORT_TICKETS = 'Support Tickets';
  static MODULE_NAME_INBOX = 'Inbox';
  static MODULE_NAME_SYNC_DASHBOARD = 'Sync Dashboard';
  static BILL_APPROVE_SCREEN = 'BILL_APPROVE_SCREEN';
  static PAYMENT_APPROVE_SCREEN = 'PAYMENT_APPROVE_SCREEN';


  static MODULE_NAME_PURCHASE_ORDER = 'Purchase Orders';

  // ========================= Create Screen Buttons=================

  static RESET_BUTTON = 'Reset Button';
  static ADD_CARD = 'Add Card';
  static CREATE_CARD = 'Create Card';
  static CREATE_ACCOUNT = 'Create Account';
  static CREATE_ITEM = 'Create Item';
  static UPLOAD_ACCOUNT = 'Upload Account';
  static UPLOAD_ITEM = 'Upload Item';
  static UPLOAD_INVOICE = 'Upload Invoice';
  static ADD_TRANSACTIONS = 'Add Transactions';
  static SCHEDULE_BUTTON = 'Schedule';
  static PAY = 'Pay Button';
  static DOWNLOAD_ATTACHMENT = 'Download Attachment';
  static VIEW_AUDIT_TRAIL = 'View Audit Trail';
  static REJECT = 'Reject';
  static APPROVE_REASSING = 'Approve & Reassign';
  static SAVE_AS_APPROVED = 'Save As Approved';
  static SAVE_FOR_APPROVED = 'Save for Approved';
  static SAVE = 'Save';
  static SUBMIT = 'Submit';
  static APPROVE = 'Approve';
  static RESUBMIT = 'Resubmit';
  static CREATE_PO_RECEIPT = 'Create PO Receipt';
  static APPROVE_FINALIZE = 'Approve & Finalize';
  static SAVE_AS_DRAFT = 'Save As Draft';
  static SUBMIT_FOR_APPROVED = 'Submit For Approval';
  static CREATE_BILL_TEMPLATE = 'Create Bill Template';
  static CREATE_SCHEDULE = 'Create Schedule';
  static CREATE_CREDIT_NOTE = 'Create Credit Note';
  static CREATE_SUPPORT_TICKET = 'Crete support ticket';
  static INBOX_UPLOAD = 'add upload files to processing queue';
  static CONFIGURATION_SUBMIT = 'Save';

  // ========================= Bill module tab navigation =================

  static BILLS_TAB = 'Bills Tab';
  static BILLS_TEMPLATES_TAB = 'Bills Templates Tab';
  static RECURRING_BILLS_TAB = 'Recurring Bills Tab';
  static CREDIT_NOTES_TAB = 'Credit Notes Tab';

  // ========================= Action names =================

  static CREATE_SCREEN = 'CREATE_SCREEN';
  static UPLOAD_SCREEN = 'UPLOAD_SCREEN';
  static PAY_SCREEN = 'PAY_SCREEN';
  static CONFIGURE_RECURRING_BILL = 'CONFIGURE_RECURRING_BILL';
  static PROCESS_BILL_SCREEN = 'PROCESS_BILL_SCREEN';
  static TABLE_ACTIONS = 'TABLE_ACTIONS';
  static TABLE_HEADER_ACTIONS = 'TABLE_HEADER_ACTIONS';
  static SCREEN_NAVIGATION = 'SCREEN_NAVIGATION';
  static CREATE: 'Create';
  static UPLOAD_PROJECT_CODE: 'Upload Project Code';
  static CREATE_AUTOMATION: 'Create Automation';


  //-----VENDOR

  static CREATE_VENDOR = 'Create Vendor';
  static CREATE_INVITE = 'Create & Invite';
  static SEND_AN_INVITATION = 'Send An Invitation';
  static SEND_INVITATION = 'Send Invitation';
  static IMPORT_VENDORS = 'Import Vendors';
  static VENDOR_REQUESTS = 'Vendor Requests';
  static VENDOR_GROUPS = 'Vendor Group';
  static COMMUNITY_VENDOR = 'Community Vendor';

  static VENDOR = 'Vendor';
  static VENDOR_INVITATIONS = 'Vendor Invitations';
  static COMMUNITY_VENDORS = 'Community Vendors';


  // USER

  static CREATE_USER = 'Create User';
  static CREATE_ROLES = 'Create Roles';
  static MODULE_NAME_ROLES = 'Roles';

  // EXPENSES
  static CREATE_EXPENSES = 'Create Expense';

  // ========================= Dashboard tables module name =================

  static DISCOUNT_APPLICABLE_BILLS_TABLE = 'Discount applicable bills';
  static BILLS_AWAITING_YOUR_APPROVAL_TABLE = 'Bills - awaiting your approval';
  static PO_AWAITING_YOUR_APPROVAL_TABLE = 'Purchase Orders - awaiting your approval';
  static EXPENSE_AWAITING_YOUR_APPROVAL_TABLE = 'Expense reports - awaiting your approval';

  /// Setting Module
  static MODULE_NAME_SETTINGS = 'Settings';
  static MODULE_NAME_COMPANY_PROFILE = 'Company Profile';
  static MODULE_NAME_DEPARTMENTS = 'Departments';
  static MODULE_NAME_GENERAL_SETTINGS = 'General Settings';
  static MODULE_NAME_MANDATORY_FIELDS_CONFIGURATION = 'Mandatory Field Configuration';
  static MODULE_NAME_ONLINE_PAYMENTS = 'Online Payments';
  static MODULE_NAME_FUNDING_ACCOUNTS = 'Funding Accounts';
  static MODULE_NAME_FEATURE_SETTINGS = 'Feature Settings';
  static MODULE_NAME_REMINDERS = 'Reminders';


  static CREATE_FUNDING_ACCOUNT = 'Create Funding Account';

  // ========================= Vendor community =================

  static MODULE_NAME_COUSTOMER = 'Customer';
  static MODULE_NAME_VENDOR_COMMUNITY_DASHBOARD_INVOICE_TABLE = 'Vendor Community Dashboard Invoice Table';
  static MODULE_NAME_VENDOR_COMMUNITY_DASHBOARD_PO_TABLE = 'Vendor Community Dashboard Purchase orders Table';

  static MODULE_VENDOR_COMMUNITY_DASHBOARD = 'Vendor Community Dashboard';
  static MODULE_VENDOR_COMMUNITY_PO = 'Vendor Community PO';
  static MODULE_VENDOR_COMMUNITY_COMPANY_PROFILE  = 'Vendor Community Company profile';
  static MODULE_VENDOR_COMMUNITY_DIGITAL_CARDS = 'Vendor Community Digital Cards';

  // Invoice module

  static MODULE_NAME_INVOICES = 'Invoices';
  static MODULE_NAME_INVOICES_TEMPLATES = 'Invoice Templates';
  static MODULE_NAME_RECURRING_INVOICES = 'Recurring Invoice';
  static MODULE_NAME_PAYMENTS_INVOICES = 'Payments Invoice';
  static MODULE_NAME_INVOICES_CREDIT_NOTES = 'Invoice Credit Notes';


}
